import { Component, OnInit } from '@angular/core';
import { StockService } from 'src/app/services/stock/stock.service';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-all-stock-ug',
  templateUrl: './all-stock-ug.component.html',
  styleUrls: ['./all-stock-ug.component.css']
})
export class AllStockUgComponent implements OnInit{
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  vehicles: any[] = [];
  public isInProgress: boolean = false;

  // Column Definitions: Defines the columns to be displayed.
    colDefs: ColDef[] = [
      { field: "bl_no", headerName: "B/L No", filter: true },
      { field: "make", filter: true },
      { field: "model",filter: true },
      { field: "chassis_no",
        headerName: "Chassis No",
        filter: true,
        cellRenderer: (params: any) => {
          if (!params.value) return "";
          return `<a href="/view-vehicle-details/${params.data.vehicle_id}" target="_blank">${params.value}</a>`;
        }
      },
      { field: "engine_no", headerName: "Engine No", filter: true },
      { field: "engine_cc", headerName: "Engine CC", valueFormatter: this.numberFormatter, filter: "agNumberColumnFilter" },
      { field: "transm", headerName: "Transmission", filter: true },
      { field: "body_type", headerName: "Body Type", filter: true },
      { field: "drive", filter: true },
      { field: "fuel", filter: true },
      { field: "mileage", headerName: "Mileage", valueFormatter: this.numberFormatter, filter: "agNumberColumnFilter" },
      { field: "reg_no", headerName: "Reg No", filter: true },
      { field: "colour", filter: true },
      { field: "month_yr", headerName: "Month/Year", filter: true },
      {
        field: "duty_paid",
        headerName: "Duty Paid",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "do_chg",
        headerName: "D.O Charges",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "unbs_chg",
        headerName: "UNBS",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "port_chg",
        headerName: "Port Charges",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "toll_chg",
        headerName: "Toll Charges",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "fp_chg",
        headerName: "Foreign Permit Charges",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "np_chg",
        headerName: "Number Plate Charges",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "ke_ins_chg",
        headerName: "KE Ins. Charges",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "agcy_fees",
        headerName: "Agency Fees",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "other_charges",
        headerName: "Other Charges",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "total",
        headerName: "Total",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      {
        field: "selling_rice",
        headerName: "Selling Price",
        valueFormatter: this.currencyFormatter,
        filter: "agNumberColumnFilter"
      },
      { field: "agency", headerName: "Agency", filter: true },
      { field: "location_name", headerName: "Location", filter: true },
      { field: "branch_name", headerName: "Branch", filter: true },
      {
        field: "status",
        headerName: "Status",
        valueFormatter: this.statusFormatter,
      },
      {
        field: "vessel_eta",
        headerName: "Vessel ETA",
        valueFormatter: this.dateFormatter.bind(this),
        filter: true
      }
    ];

  ngOnInit(): void {
    this.isInProgress=true;
    this.fetchAllStockUg();
  }

  constructor(
        private stockService:StockService,
      ){}

      fetchAllStockUg():void{
        this.stockService.getAllStockUg()
        .subscribe({
          next: (response) => {
            if(response.status==='success'){
              this.vehicles = response.data;
              this.isInProgress=false;
              this.errorMessage=null;
            }else if(response.status==='no_data'){
               this.errorMessage=response.message;
               this.isInProgress=false;
            }else{
              this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
              this.isInProgress=false;
            }
          },
          error: (error) => {
            this.errorMessage=error;
            this.isInProgress=false;
          }
        });
      }

      currencyFormatter(params: any): string {
        if (params.value == null || params.value === '') return '';
        return new Intl.NumberFormat('en-UG', {
          style: 'currency',
          currency: 'UGX',
          minimumFractionDigits: 2
        }).format(params.value);
      }

      numberFormatter(params: any): string {
        if (params.value == null || params.value === '') return '';
        return new Intl.NumberFormat('en-UG').format(params.value);
      }

      dateFormatter(params: any): string {
        if (!params.value) return "";
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return params.value; // fallback if it's not a valid date
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }

    statusFormatter(params: any): string {
        const map: { [key: number]: string } = {
          0: "En route",
          1: "At CFS",
          2: "In Stock",
          3: "Being Transferred",
          4: "On Road Test",
          5: "Sold",
          6: "Not Shipped",
          7: "In Service",
          8: "Pending Transit"
        };
        return map[params.value] ?? "Unknown";
    }
}
